import axios from "axios";

const baseUrl = process.env.REACT_APP_API_BASE;
class Service {
    constructor(props) {
        this.refreshHeader(() => { });
    }

    refreshHeader(callback) {
        const sessionToken = sessionStorage.getItem("token");
        let srh = {
            headers: {
                "Content-Type": "application/json",
                "Authorization": sessionToken
            },
        };

        let service = axios.create(srh);
        service.interceptors.response.use(this.handleSuccess, this.handleError);
        this.service = service;
        return callback();
    }

    handleSuccess(response) {
        return response;
    }

    handleError = (error) => {
        let code = 400;
        let message = "";
        if (typeof error.response != "undefined") {
            if (typeof error.response?.data?.meta?.code != "undefined") {
                code = error.response.data.meta.code;
                message = error.response.data.meta.message;
            }
            if (error.response.statusText === "Unauthorized") {
                code = error.response.status;
                message = error.response.statusText;
            }
        }

        switch (code) {
            case 401:
                sessionStorage.removeItem("token");
                window.location.href = `${process.env.PUBLIC_URL}/`;
                break;
            case 404:
                break;
            default:
                if (message !== "") {
                }
                break;
        }
        return Promise.reject(error);
    };

    redirectTo = (document, path) => {
        document.location = path;
    };


    async get(path, callback) {
        let response = await this.service.request(`${baseUrl}/${path}`);
        return callback(response.status, response.data);
        // return response;
    }



    async patch(path, payload, callback) {
        let response = await this.service.request({
            method: "PATCH",
            url: `${baseUrl}/${path}`,
            responseType: "json",
            data: payload,
        });
        return callback(response.status, response.data);

    }

    async post(path, payload, callback) {
        let response = await this.service.request({
            method: 'POST',
            url: `${baseUrl}/${path}`,
            responseType: 'json',
            data: payload
        })
        return callback(response);
    }

    async put(path, payload, callback) {
        let response = await this.service.request({
            method: "PUT",
            url: `${baseUrl}/${path}`,
            responseType: "json",
            data: payload,
        });
        callback(response.status, response.data);
        return response;
    }

    async delete(path, payload, callback) {
        let response = await this.service.request({
            method: 'DELETE',
            url: `${baseUrl}/${path}`,
            responseType: "json",
            data: payload
        });
        return callback(response);
        // return response;
    }
}

export default new Service();
